export const TIPO_FILTRO = {
  TEXTO: 1,
  OPCOES: 2,
};
